import { getCloudFunctionBaseUrl } from '../../config'
import { get, post, patch, destroy } from './index'

export const Users = {
	index: ({
		page = 0,
		searchTerm,
		role,
		disabled,
		toDate,
		fromDate,
		permissionGroups,
		permissionGroupId
	} = {}) =>
		get('/users', {
			params: {
				searchTerm,
				page,
				role,
				disabled,
				toDate,
				fromDate,
				permissionGroups,
				permissionGroupId
			}
		}),
	single: (id) =>
		get(`/users/${id}`),
	create: ({ email, phone, name, role, internalId, permissionGroupId, locationIds, password, isSSOEnabled } = {}) =>
		post('/users', { email, phone, name, role, internalId, permissionGroupId, locationIds, password, isSSOEnabled }),
	signUp: (params) =>
		post('/users/sign-up', params),
	update: (id, {
		disabled,
		name,
		phone,
		email,
		internalId,
		role,
		locationIds,
		password
	} = {}) =>
		patch(`/users/${id}`, {
			disabled,
			name,
			phone,
			email,
			internalId,
			role,
			locationIds,
			password
		}),
	remove: (id) =>
		destroy(`/users/${id}`),
	fetchTeams: () => get('/users/teams'),
	fetchIndustries: () => get('/users/industries'),
	exists: ({ email, phone } = {}) => get('/users/exists', {
		params: {
			email,
			phone
		}
	}),
	forgotPassword: (email) => get('/forgotPassword', {
		baseURL: getCloudFunctionBaseUrl(),
		params: {
			email
		}
	}),
	sso: () => get('/users/sso'),
	isSso: (email) => get('/users/is-sso', {
		params: {
			email
		}
	}),
	trackLogin: () => post('/users/track-login'),
	claimSession: ({ agent, deviceId, deviceLabel } = {}) =>
		post('/users/sessions/claim', { agent, deviceId, deviceLabel }),
	forceSession: ({ agent, deviceId, deviceLabel } = {}) =>
		post('/users/sessions/force', { agent, deviceId, deviceLabel }),
	signOutSession: () => post('/users/sessions/sign-out'),
	reportSessionActivity: () => post('/users/sessions/activity'),
	expireSession: () => post('/users/sessions/expire')
}
